import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "rate-card-wrapper" }
const _hoisted_2 = {
  key: 1,
  class: "divider"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RateTypeCard = _resolveComponent("RateTypeCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.rates?.mobile)
      ? (_openBlock(), _createBlock(_component_RateTypeCard, {
          key: 0,
          amount: _ctx.rates.mobile,
          hasMultipleRates: _ctx.singleRate?.hasMultipleRates || _ctx.rates.mobile.hasMultipleRates,
          title: _ctx.singleRate?.name,
          ratePerMinute: _ctx.rates.mobile.minutes,
          isFlat: _ctx.singleRate?.isFlat || _ctx.rates.mobile.isFlat,
          type: "mobile"
        }, null, 8, ["amount", "hasMultipleRates", "title", "ratePerMinute", "isFlat"]))
      : _createCommentVNode("", true),
    (_ctx.rates?.mobile && _ctx.rates?.landline)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : _createCommentVNode("", true),
    (_ctx.rates?.landline)
      ? (_openBlock(), _createBlock(_component_RateTypeCard, {
          key: 2,
          amount: _ctx.rates.landline,
          isMobile: false,
          hasMultipleRates: _ctx.singleRate?.hasMultipleRates || _ctx.rates.landline.hasMultipleRates,
          title: _ctx.singleRate?.name,
          ratePerMinute: _ctx.rates.landline.minutes,
          isFlat: _ctx.singleRate?.isFlat || _ctx.rates.landline.isFlat,
          type: "landline"
        }, null, 8, ["amount", "hasMultipleRates", "title", "ratePerMinute", "isFlat"]))
      : _createCommentVNode("", true),
    (_ctx.singleRate && _ctx.rates?.premium)
      ? (_openBlock(), _createBlock(_component_RateTypeCard, {
          key: 3,
          amount: _ctx.rates?.premium,
          isMobile: false,
          hasMultipleRates: _ctx.singleRate.hasMultipleRates,
          title: _ctx.singleRate?.name,
          ratePerMinute: _ctx.rates?.premium?.minutes,
          isFlat: _ctx.singleRate?.isFlat || _ctx.rates.premium.isFlat,
          type: "premium"
        }, null, 8, ["amount", "hasMultipleRates", "title", "ratePerMinute", "isFlat"]))
      : _createCommentVNode("", true)
  ]))
}